(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frez-europe-distributor"]) return;
  try {
    
  (() => {
    const countries = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE GB CH NO IS LI'.split(' '));
    const key = 'frez:europe-distributor:v1:seen';
    document.querySelectorAll('.frez-europe').forEach((dialog) => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      const preview = dialog.dataset.preview === 'true';
      if (!preview && !countries.has(dialog.dataset.country)) return;
      if (typeof dialog.showModal !== 'function') return;
      const seen = () => {
        try { return localStorage.getItem(key) !== null; } catch { return true; }
      };
      if (!preview && seen()) return;
      dialog.querySelectorAll('[data-europe-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      window.addEventListener('storage', (event) => {
        if (!preview && event.key === key && event.newValue !== null && dialog.open) dialog.close();
      });
      window.addEventListener('pageshow', (event) => {
        if (!preview && event.persisted && dialog.open) dialog.close();
      });
      const open = () => window.setTimeout(() => {
        if (!preview && seen()) return;
        if (document.querySelector('dialog[open], [aria-modal="true"]')) return;
        if (document.visibilityState === 'hidden') return;
        try {
          dialog.showModal();
          if (!preview) localStorage.setItem(key, '1');
        } catch {
          if (dialog.open) dialog.close();
        }
      }, 1200);
      if (document.readyState === 'complete') open();
      else window.addEventListener('load', open, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
